import { Injectable } from '@angular/core';

export interface Alert {
  type: 'success' | 'info' | 'warning' | 'danger';
  msg: string;
  timeout?: number;
  toast?: boolean;
  position?: string;
  scoped?: boolean;
  count?: number;
  timer?: any;
  close?: () => void;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private alerts: Alert[] = [];
  private alertAsToast = false;
  private alertTimeout = 5000;
  private alertPosition = 'top-right';

  get(): Alert[] {
    return this.alerts;
  }

  isToast(): boolean {
    return this.alertAsToast;
  }

  success(message: string, _key?: string, _data?: unknown): void {
    this.addAlert({ type: 'success', msg: message, timeout: this.alertTimeout });
  }

  error(message: string, _key?: string, _data?: unknown): void {
    this.addAlert({ type: 'danger', msg: message, timeout: this.alertTimeout });
  }

  addAlert(alert: Alert, extAlerts?: Alert[]): Alert {
    const alerts = extAlerts ?? this.alerts;

    if (!extAlerts) {
      const existing = alerts.find(candidate => candidate.type === alert.type && candidate.msg === alert.msg);
      if (existing) {
        existing.count = (existing.count ?? 1) + 1;
        this.scheduleClose(existing, alerts);
        return existing;
      }
    }

    const alertCopy: Alert = {
      ...alert,
      count: 1,
      toast: alert.toast ?? this.alertAsToast,
      position: alert.position ?? this.alertPosition
    };

    alertCopy.close = () => this.closeAlert(alertCopy, alerts);
    alerts.push(alertCopy);
    this.scheduleClose(alertCopy, alerts);

    return alertCopy;
  }

  private scheduleClose(alert: Alert, alerts: Alert[]): void {
    if (!alert.timeout) {
      return;
    }
    if (alert.timer) {
      clearTimeout(alert.timer);
    }
    alert.timer = setTimeout(() => this.closeAlert(alert, alerts), alert.timeout);
  }

  private closeAlert(alert: Alert, alerts: Alert[]): void {
    if (alert.timer) {
      clearTimeout(alert.timer);
      alert.timer = undefined;
    }
    const index = alerts.indexOf(alert);
    if (index >= 0) {
      alerts.splice(index, 1);
    }
  }
}
